import { render, staticRenderFns } from "./BlacklistedChassisCreate.vue?vue&type=template&id=60085b61&scoped=true&"
import script from "./BlacklistedChassisCreate.vue?vue&type=script&lang=js&"
export * from "./BlacklistedChassisCreate.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedChassisCreate.vue?vue&type=style&index=0&id=60085b61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60085b61",
  null
  
)

export default component.exports